export default class SearchObject {

    constructor(props) {
        const instance = this.constructor.instance;
        if (instance) {
            return instance;
        }

        this.constructor.instance = this;

        // suggest api options
        this.Needle = props.Needle || '';
        this.SearchTags = props.SearchTags || [];
        this.Country = props.Country || [];
        this.Region = props.Region || [];
        this.SubRegion = props.SubRegion || [];
        this.City = props.City || [];
        this.combinedRegion = props.combinedRegion || '';
        this.Type = props.Type || ["euvia", "video"];
        this.hideTypeFilter = props.hideTypeFilter || false;
        this.Limit = props.Limit || 2000;

        // search object options
        this.maxItemsPerType = 5;
        this.destination = props.destination || '';
        this.tags = this.buildTags();
    }

    /**
     * Attributes list.
     *
     * @returns {({name: string, text: string}|{name: string, text: string}|{name: string, text: string}|{name: string, text: string}|{name: string, text: string})[]}
     */
    buildTags() {
        return [
            {
                name: 'beach',
                text: 'Strand',
                tags: ''
            },
            {
                name: 'club',
                text: 'Club',
                tags: ''
            },
            {
                name: 'sport',
                text: 'Sport',
                tags: ''
            },
            {
                name: 'wellness',
                text: 'Wellness',
                tags: ''
            },
            {
                name: 'family',
                text: 'Familie',
                tags: ''
            },
            {
                name: 'wlan',
                text: 'WLAN',
                tags: ''
            },
            {
                name: 'fullage',
                text: '+18',
                tags: ''
            },
            {
                name: 'pool',
                text: 'Pool',
                tags: ''
            },
            {
                name: 'cruises',
                text: 'Kreuzfahrt',
                tags: ''
            },
            {
                name: 'culture',
                text: 'Kultur',
                tags: ''
            },
            {
                name: 'nature',
                text: 'Natur',
                tags: ''
            },
            {
                name: 'city',
                text: 'Stadt',
                tags: ''
            },
        ];
    }

    setLocation(region) {
        this.resetRegion();
        let selectedRegion = region.split(',');
        switch (selectedRegion.length) {
            case 4:
                this.City.push(selectedRegion[selectedRegion.length - 1]);
                break;
            case 3:
                this.SubRegion.push(selectedRegion[selectedRegion.length - 1]);
                break;
            case 2:
                this.Region.push(selectedRegion[selectedRegion.length - 1]);
                break;
            case 1:
                this.Country.push(selectedRegion[selectedRegion.length - 1]);
        }
    }

    resetRegion() {
        this.Country = [];
        this.Region = [];
        this.SubRegion = [];
        this.City = [];
        this.combinedRegion = '';
    }

    resetType(){
        this.Type = ["euvia", "video"];
        this.hideTypeFilter = false;
    }

    openWindow(obj) {
        switch (obj.Type) {
            case 'euvia':
                window.location.href = `/details/angebot/${obj.Id}`;
                break;
            case 'video':
                window.location.href = `/details/video/${this.sanitize(obj.Title)}/${obj.Id}`;
                break;
        }
    }

    /**
     * try to make a quite similar slughelper like in the TYPO3 core.
     *
     * @param str
     * @returns {string}
     */
    sanitize(str) {
        let map = {
            'eur': '€',
            '-': ' |_',
            'ae': 'ä|Ä',
            'ue': 'ü|Ü',
            'oe': 'ö|Ö',
            'ss': 'ß',
            'a': 'á|à|ã|â|À|Á|Ã|Â',
            'e': 'é|è|ê|É|È|Ê',
            'i': 'í|ì|î|Í|Ì|Î',
            'o': 'ó|ò|ô|õ|Ó|Ò|Ô|Õ',
            'u': 'ú|ù|û|Ú|Ù|Û',
            'c': 'ç|Ç',
            'n': 'ñ|Ñ'
        };

        for (let pattern in map) {
            str = str.replace(new RegExp(map[pattern], 'g'), pattern);
        }

        str = str.replace(/[^a-z0-9]/gi, '-')
            .replace(/([-]{1,})/g, '-')
            .toLowerCase();

        return str;
    }

    /**
     * generate suggest object for api request
     *
     * @returns {object}
     */
    apiSuggestObject() {
        // suggest use always this needed types
        const suggestSearchTypes = ['euvia','video','country','region','subRegion'];
        return {
            "Needle": this.Needle,
            "SearchTags": this.SearchTags,
            "Country": this.Country,
            "Region": this.Region,
            "SubRegion": this.SubRegion,
            "City": this.City,
            "Type": suggestSearchTypes,
            "Limit": 100
        }
    }

    /**
     * generate object for search result page
     *
     * @returns {object}
     */
    searchObject() {
        return {
            "Needle": this.Needle,
            "SearchTags": this.SearchTags,
            "Country": this.Country,
            "Region": this.Region,
            "SubRegion": this.SubRegion,
            "City": this.City,
            "combinedRegion": this.combinedRegion,
            "Type": this.Type,
            "hideTypeFilter": this.hideTypeFilter,
            "Limit": this.Limit
        }
    }

    toString() {
        return JSON.stringify(this.searchObject());
    }
}